"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _MenuList = _interopRequireDefault(require("@mui/material/MenuList"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _EDSContext = require("./../EDSContext/EDSContext");
var _IconButton = _interopRequireDefault(require("./../IconButton"));
var _Tooltip = _interopRequireDefault(require("./../Tooltip"));
var _Popper = _interopRequireDefault(require("./../Popper"));
var _makeStylesInternal = _interopRequireDefault(require("./../makeStyles/makeStylesInternal"));
var _useTextOverflow2 = _interopRequireDefault(require("./../MasterDetail/internal/useTextOverflow"));
var _useMediaQuery = _interopRequireDefault(require("./../useMediaQuery"));
var _ChevronRight = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronRight"));
var _MoreHorizontal = _interopRequireDefault(require("@ellucian/ds-icons/lib/MoreHorizontal"));
var _Dashboard = _interopRequireDefault(require("@ellucian/ds-icons/lib/Dashboard"));
var _tokens = require("../styles/tokens");
var _excluded = ["className", "children", "leadingIcon", "hideLeadingIcon", "classes", "edsContext"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var useStyles = (0, _makeStylesInternal.default)(function (theme) {
  var _$listItemA;
  return {
    root: {
      overflow: 'auto',
      '& $listItem > a': (_$listItemA = {
        maxWidth: '6.25rem',
        // 100px
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        display: 'inherit'
      }, _$listItemA[theme.breakpoints.up('md')] = {
        maxWidth: '18.75rem' // 300px
      }, _$listItemA),
      '& $listItem, & $listItem a, & $listItem a:hover': {
        fontSize: _tokens.fontSizeDefault,
        color: theme.palette.text.secondary,
        fill: theme.palette.text.secondary,
        cursor: 'pointer',
        textDecoration: 'none'
      },
      '& $listItem a:hover, & $listItem a:active': {
        color: theme.palette.grey[600],
        fill: theme.palette.grey[600],
        textDecoration: 'underline'
      },
      '& $listItem:last-child, & $listItem:last-child a, & $listItem:last-child a:hover': {
        color: theme.palette.text.primary
      },
      '& $listItem:last-child a:hover': {
        textDecoration: 'underline'
      },
      '& $listItem a:disabled': {
        color: 'inherit'
      },
      '& $disabledBreadcrumb': {
        pointerEvents: 'none',
        '& a': {
          color: theme.palette.action.disabled
        }
      }
    },
    listItem: {},
    breadcrumbs: {
      display: 'flex',
      alignItems: 'center',
      gap: _tokens.spacing30,
      margin: _tokens.spacing40,
      padding: 0,
      listStyle: 'none'
    },
    chevronContainer: {
      display: 'flex',
      alignItems: 'center',
      pointerEvents: 'none'
    },
    chevron: {
      width: _tokens.fontSizeSmall,
      height: _tokens.fontSizeSmall,
      fill: theme.palette.text.secondary
    },
    disabledBreadcrumb: {},
    tooltip: {
      '&, & a, & a:hover': {
        color: theme.palette.common.white,
        textDecoration: 'none'
      }
    },
    popper: {
      padding: "0 " + _tokens.spacing30,
      '& $paper': {
        padding: 0,
        '& a': {
          color: theme.palette.text.primary,
          textDecoration: 'none',
          fontSize: theme.typography.fontSize
        },
        '& a:hover, & a:focus': {
          color: theme.palette.text.primary,
          textDecoration: 'underline'
        },
        '& $focusVisible': {
          background: theme.palette.common.white
        }
      }
    },
    paper: {},
    menuItem: {
      whiteSpace: 'inherit',
      '&:hover, &:focus, &:active': {
        background: 'none'
      }
    },
    focusVisible: {},
    moreBreadcrumbs: {
      border: _tokens.borderWidthThin + " solid " + _tokens.colorGlobalBorderDefault,
      width: _tokens.spacing50,
      height: _tokens.spacing40,
      display: 'flex',
      alignItems: 'center',
      paddingRight: _tokens.spacing20,
      paddingLeft: _tokens.spacing20,
      borderRadius: _tokens.spacing20,
      cursor: 'pointer',
      '& svg': {
        fill: theme.palette.grey[500]
      },
      '&:hover': {
        backgroundColor: theme.palette.default.light
      },
      '&:active': {
        backgroundColor: theme.palette.default.dark,
        outline: _tokens.borderWidthThick + " solid " + _tokens.colorBorderGlobalFocus
      }
    },
    leadingIcon: {
      display: 'flex',
      alignItems: 'center'
    }
  };
}, {
  index: 2
});

/**
 * Breadcrumbs are a navigation pattern that helps users understand the hierarchy of a website or application's content,
 * facilitating easier navigation and providing context about their current location within the site's structure.
 * @done true
 * @updated v7.11.0
 * @versionAdded v7.7.0
 * @examples
 *  BreadcrumbsExample
 *  BreadcrumbsHideLeadingIcon
 *  BreadcrumbsWithCustomIcon
 *  BreadcrumbsWithDisabledItems
 *  BreadcrumbsWithLongItemNames
 */
var Breadcrumbs = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _useState = (0, _react.useState)(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var moreButtonRef = (0, _react.useRef)(null);
  var classes = useStyles();
  var isMdDown = (0, _useMediaQuery.default)(function (theme) {
    return theme.breakpoints.down('md');
  });
  var className = props.className,
    children = props.children,
    leadingIcon = props.leadingIcon,
    hideLeadingIcon = props.hideLeadingIcon,
    classesProp = props.classes,
    edsContext = props.edsContext,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var count = _react.default.Children.count(children);
  var onMoreBreadcrumbsClick = function onMoreBreadcrumbsClick(e) {
    setAnchorEl(e.currentTarget);
    setOpen(true);
  };
  var onPopperClose = function onPopperClose() {
    setOpen(false);
  };
  var ChevronIcon = function ChevronIcon() {
    return /*#__PURE__*/_react.default.createElement(_ChevronRight.default, {
      dir: edsContext.dir,
      className: classes.chevron
    });
  };
  var generateBreadcrumbs = (0, _react.useMemo)(function () {
    return function () {
      var breadcrumbs = [];
      _react.Children.forEach(children, function (child, index) {
        var Breadcrumb = function Breadcrumb() {
          var _cn;
          var disabled = child.props.disabled;
          var liRef = (0, _react.useRef)(null);
          var _useTextOverflow = (0, _useTextOverflow2.default)(liRef, '*'),
            overflow = _useTextOverflow[0];
          var ariaCurrent = index === count - 1 ? {
            'aria-current': 'true'
          } : {};
          var liElement = /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({
            ref: liRef
          }, ariaCurrent, {
            className: (0, _classnames.default)(classes.listItem, (_cn = {}, _cn[classes.disabledBreadcrumb] = disabled, _cn))
          }), child);
          return overflow ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
            title: child,
            placement: "bottom-start",
            classes: {
              tooltip: classes.tooltip
            }
          }, liElement) : liElement;
        };
        if (isMdDown && count > 2) {
          if (index === 1) {
            breadcrumbs.push( /*#__PURE__*/_react.default.createElement("li", {
              key: 'li.box' + index
            }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
              ref: moreButtonRef,
              className: (0, _classnames.default)(classes.moreBreadcrumbs, 'more-breadcrumbs'),
              color: "secondary",
              onClick: onMoreBreadcrumbsClick,
              "aria-label": "More breadcrumbs"
            }, /*#__PURE__*/_react.default.createElement(_MoreHorizontal.default, null))));
            breadcrumbs.push( /*#__PURE__*/_react.default.createElement("li", {
              "aria-hidden": "true",
              className: (0, _classnames.default)(classes.listItem, classes.chevronContainer),
              key: 'li.chevron' + index
            }, /*#__PURE__*/_react.default.createElement(ChevronIcon, null)));
          } else if (index === 0 || index === count - 1) {
            breadcrumbs.push( /*#__PURE__*/_react.default.createElement(Breadcrumb, {
              key: 'breadcrumb' + index
            }));
            breadcrumbs.push( /*#__PURE__*/_react.default.createElement("li", {
              "aria-hidden": "true",
              className: (0, _classnames.default)(classes.listItem, classes.chevronContainer),
              key: 'li.chevron' + index
            }, /*#__PURE__*/_react.default.createElement(ChevronIcon, null)));
          }
        } else {
          breadcrumbs.push( /*#__PURE__*/_react.default.createElement(Breadcrumb, {
            key: 'breadcrumb' + +index
          }));
          breadcrumbs.push( /*#__PURE__*/_react.default.createElement("li", {
            "aria-hidden": "true",
            className: (0, _classnames.default)(classes.listItem, classes.chevronContainer),
            key: 'li.chevron' + index
          }, /*#__PURE__*/_react.default.createElement(ChevronIcon, null)));
        }
      });

      // Remove the last chevron
      breadcrumbs.pop();
      return breadcrumbs;
    };
  }, [children, classes.chevronContainer, classes.disabledBreadcrumb, classes.listItem, classes.moreBreadcrumbs, classes.tooltip, count, isMdDown]);
  var onKeyDown = function onKeyDown(e) {
    var key = e.key;
    if (key === 'Escape' || key === 'Tab') {
      var _moreButtonRef$curren;
      e.preventDefault();
      onPopperClose();
      moreButtonRef == null || (_moreButtonRef$curren = moreButtonRef.current) == null || _moreButtonRef$curren.focus();
    } else if (key === 'ArrowDown') {
      var _e$target, _nextLiSibling$queryS;
      var nextLiSibling = (_e$target = e.target) == null || (_e$target = _e$target.parentNode) == null ? void 0 : _e$target.nextSibling;
      nextLiSibling == null || (_nextLiSibling$queryS = nextLiSibling.querySelector('a')) == null || _nextLiSibling$queryS.focus();
    } else if (key === 'ArrowUp') {
      var _e$target2, _previousSibling$quer;
      var previousSibling = (_e$target2 = e.target) == null || (_e$target2 = _e$target2.parentNode) == null ? void 0 : _e$target2.previousSibling;
      previousSibling == null || (_previousSibling$quer = previousSibling.querySelector('a')) == null || _previousSibling$quer.focus();
    }
  };
  return /*#__PURE__*/_react.default.createElement("nav", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, classesProp == null ? void 0 : classesProp.root, className),
    ref: ref,
    "aria-label": edsContext.formatMessage('component.Breadcrumbs.label')
  }, rest), /*#__PURE__*/_react.default.createElement("ol", {
    className: classes.breadcrumbs
  }, !hideLeadingIcon && /*#__PURE__*/_react.default.createElement("li", {
    className: classes.leadingIcon,
    "aria-hidden": "true"
  }, leadingIcon), generateBreadcrumbs()), isMdDown && /*#__PURE__*/_react.default.createElement(_Popper.default, {
    className: classes.popper,
    role: "dialog",
    open: open,
    onClickAway: onPopperClose,
    onClose: onPopperClose,
    arrow: true,
    anchorEl: anchorEl,
    PaperProps: {
      className: classes.paper,
      'aria-live': 'off'
    }
  }, /*#__PURE__*/_react.default.createElement(_MenuList.default, {
    autoFocusItem: open,
    onKeyDown: onKeyDown,
    onFocus: function onFocus(e) {
      var _e$target3;
      return (_e$target3 = e.target) == null || (_e$target3 = _e$target3.querySelector('a')) == null ? void 0 : _e$target3.focus();
    },
    "data-testid": "breadcrumbs-menu-items"
  }, _react.Children.map(children, function (child, index) {
    var inRange = index > 0 && index < count - 1;
    return inRange ? /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: 'mp.box' + index,
      onClick: !child.props.disabled && onPopperClose,
      className: classes.menuItem,
      classes: {
        focusVisible: classes.focusVisible
      },
      disabled: child.props.disabled
    }, child) : null;
  }))));
});
Breadcrumbs.muiName = 'Breadcrumbs';
Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.propTypes = {
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * Classes used to extend original style object.
   */
  classes: _propTypes.default.object,
  /**
   * A CSS class that will be applied to the root element.
   */
  className: _propTypes.default.string,
  /**
   * The breadcrumb items to be rendered within the Breadcrumbs component.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   * *Applied only to the root element*
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object]),
  /**
   * The icon displayed at the beginning of the breadcrumb trail
   */
  leadingIcon: _propTypes.default.node,
  /**
   * Controls the visibility of the leading icon at the start of the breadcrumb trail.
   */
  hideLeadingIcon: _propTypes.default.bool
};
Breadcrumbs.defaultProps = {
  hideLeadingIcon: false,
  leadingIcon: /*#__PURE__*/_react.default.createElement(_Dashboard.default, null)
};
var _default = exports.default = (0, _EDSContext.withEDSContext)(Breadcrumbs);